export default __webpack_public_path__ + "static/media/Pin-Scheduled.0d1ed98a.svg";